module.exports = __webpack_public_path__ + "static/media/fiberglassTank.1a8c01ba.jpg";